export const wrongMsgs = [
  { text: "Are you sure?", emoji: "🤔" },
  { text: "It does not work", emoji: "🤨" },
  { text: "Nope...", emoji: "🧐" },
]

const pick = (xs) => xs[Math.floor(Math.random() * xs.length)]

export const randomWrongMsg = () => pick(wrongMsgs)
